import { gql } from "@apollo/client";
export const FindCompanyBankBalances = gql `
  query Query($input: FindCompanyBankBalancesInput!) {
    FindCompanyBankBalances(input: $input)
  }
`;
